import type { DayType, IsoWeekday } from '../types';

export const isoWeekdays: { value: IsoWeekday; shortLabel: string; label: string }[] = [
  { value: 1, shortLabel: 'Mon', label: 'Monday' },
  { value: 2, shortLabel: 'Tue', label: 'Tuesday' },
  { value: 3, shortLabel: 'Wed', label: 'Wednesday' },
  { value: 4, shortLabel: 'Thu', label: 'Thursday' },
  { value: 5, shortLabel: 'Fri', label: 'Friday' },
  { value: 6, shortLabel: 'Sat', label: 'Saturday' },
  { value: 7, shortLabel: 'Sun', label: 'Sunday' },
];

export const isWeekdayAllowed = (dayType: DayType, weekday: IsoWeekday): boolean =>
  dayType === 'ALL' || (dayType === 'WD' ? weekday <= 5 : weekday >= 6);

/** The concrete day types a band's day type covers. `ALL` reaches both, which is
 * how an unsplit band registers against a split grid — and the reason a fold or
 * an index never special-cases it. */
export const dayTypeTargets = (dayType: DayType): Exclude<DayType, 'ALL'>[] =>
  dayType === 'ALL' ? ['WD', 'WE'] : [dayType];

export const weekdaySpotKey = (weekday: IsoWeekday): `_${IsoWeekday}` => `_${weekday}`;

export const dayTypeOfWeekday = (weekday: IsoWeekday): Exclude<DayType, 'ALL'> => (weekday <= 5 ? 'WD' : 'WE');
